import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit'
import { IClientWithSettings, SimpleClient } from 'shared/models/Client'
import clientsApi from './clients.service'

export const clientsAdapter = createEntityAdapter<IClientWithSettings>({
  // @ts-expect-error old code
  selectId: (client) => client.id,
  sortComparer: (x, y) =>
    x.clientName.toLowerCase().localeCompare(y.clientName.toLowerCase()),
})

export const reducer = createSlice({
  name: 'clientStore',
  initialState: clientsAdapter.getInitialState({
    currentId: null as string | null,
    clients: [] as SimpleClient[],
    isSettingClient: false,
  }),
  reducers: {
    setActiveClientIdStarted: (state) => {
      state.isSettingClient = true
    },
    setActiveClientId: (state, action: PayloadAction<string | null>) => {
      state.currentId = action.payload
      state.isSettingClient = false
    },
    setUserClients: (state, action: PayloadAction<SimpleClient[]>) => {
      state.clients = action.payload
    },
  },
  extraReducers(builder) {
    builder.addMatcher(
      clientsApi.endpoints.getClient.matchFulfilled,
      clientsAdapter.addOne
    )
  },
})

export default reducer
